// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .matrix-skeleton .ant-skeleton .ant-skeleton-button {
  height: 22px;
}
/*# sourceMappingURL=MatrixSkeleton.css.map */`, "",{"version":3,"sources":["webpack://./MatrixSkeleton.less","webpack://./src/components/Matrices/MatrixSkeleton/MatrixSkeleton.less"],"names":[],"mappings":"AAAA;EAEE,YAAA;ACAF;AACA,6CAA6C","sourcesContent":[".presize-root { \n .matrix-skeleton .ant-skeleton .ant-skeleton-button {\n  height: 22px;\n}\n \n}",".presize-root .matrix-skeleton .ant-skeleton .ant-skeleton-button {\n  height: 22px;\n}\n/*# sourceMappingURL=MatrixSkeleton.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
